import {dialogApi} from '../../../api/dialogApi'
import {useCallback, useEffect, useState} from 'react'
import {UserWelcomePage} from './UserWelcomePage/UserWelcomePage'
import {UserResponsePage} from './UserResponsePage/UserResponsePage'
import {useParams} from 'react-router'
import type {IStoredDialogUserAvatar} from '../../../types'

export const UserDialogWrapper = (): React.ReactElement => {
  const [showWelcomePage, setShowWelcomePage] = useState<boolean>(true)
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: details} = dialogApi.useDialogDetails(dialogId ?? '')

  useEffect(() => {
    const sessionIds = JSON.parse(localStorage.getItem(`dialogUserIds`) || '{}')
    const orgId = details?.orgId ?? ''
    const sessionId = sessionIds[orgId] || null
    const data = localStorage.getItem(`dialogUserAvatars`)
    const parsedData = data && JSON.parse(data)
    const userAvatar =
      Array.isArray(parsedData) &&
      (parsedData.find(
        (item: IStoredDialogUserAvatar) => item.orgId === details?.orgId,
      ) ??
        null)
    if (sessionId && userAvatar) setShowWelcomePage(false)
  }, [details?.orgId])

  const handleInvalidAvatar = useCallback((): void => {
    const orgId = details?.orgId
    if (orgId) {
      const avatars = JSON.parse(
        localStorage.getItem('dialogUserAvatars') || '[]',
      )
      const filtered = (avatars as IStoredDialogUserAvatar[]).filter(
        a => a.orgId !== orgId,
      )
      localStorage.setItem('dialogUserAvatars', JSON.stringify(filtered))
    }
    setShowWelcomePage(true)
  }, [details?.orgId])

  return (
    <>
      {showWelcomePage && (
        <UserWelcomePage setShowWelcomePage={setShowWelcomePage} />
      )}
      {!showWelcomePage && (
        <UserResponsePage
          dialogDetails={details}
          onInvalidAvatar={handleInvalidAvatar}
        />
      )}
    </>
  )
}
